import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { campsenum } from './../../../models/enums.generated';
import { camps } from './../../../models/models.generated';

@Component({
    selector: 'app-sort-camps',
    templateUrl: './sort-camps.component.html',
    styleUrls: ['./sort-camps.component.scss'],
    standalone: false
})
export class SortCampsComponent implements OnInit {

    constructor() { }

    @Input()
    public model: camps.SortParameters;

    @Input()
    public sorting: string[];

    @Output()
    public changed = new EventEmitter<camps.SortParameters>();

    ngOnInit() {
    }

    public isByAsc(): boolean {
        return this.model.order == campsenum.SortOrder.Asc;
    }

    public isByDesc(): boolean {
        return this.model.order == campsenum.SortOrder.Desc;
    }

    public sortByAsc() : void {
        this.model.order = campsenum.SortOrder.Asc;
        this.changed.emit(this.model);
    }

    public sortByDesc() : void {
        this.model.order = campsenum.SortOrder.Desc;
        this.changed.emit(this.model);
    }

    public setOrder(item: string) {
        this.model.fieldName = item;
        this.changed.emit(this.model);
    }
}
